export const scrollIntoView = (top: number, behavior: ScrollBehavior = 'smooth') => {
  const content = document.querySelector('.content')
  content?.scrollTo({
    top,
    left: 0,
    behavior,
  })
}
